import request from "../../../../utils/api";

const url = "api/v1/companies"

export const getOverhead = (company_id, params) => request(`${url}/${company_id}/expenses`, { params });
export const createOverhead = (id, body) => request(`${url}/${id}/expenses`, { method: "post", body });
export const updateOverhead = (company_id, overhead_id, body) => request(`${url}/${company_id}/expenses/${overhead_id}`, { method: "put", body });
export const deleteOverhead = (company_id, overhead_id) => request(`${url}/${company_id}/expenses/${overhead_id}`, { method: "delete" })
export const copyOverhead = (company_id, body) => request(`${url}/${company_id}/expenses/copy`, { method: "post", body });


// WEBPACK FOOTER //
// ./src/modules/company/pages/overhead/service.js